import { CheckBox } from "@mittwald/flow-components/dist/components/CheckBox";
import { ColumnLayout } from "@mittwald/flow-components/dist/components/ColumnLayout";
import { Section } from "@mittwald/flow-components/dist/components/Section";
import { TextField } from "@mittwald/flow-components/dist/components/TextField";
import TranslationProvider from "@mittwald/flow-components/dist/components/TranslationProvider/TranslationProvider";
import React from "react";
import { StepHeaderItem } from "../../StepHeaderItem";
import { Section as NewSection } from "@mittwald/flow-react-components";

export const DetailsStepContent: React.FC = () => {
  return (
    <TranslationProvider name="detailsStepContent" type="component">
      <NewSection>
        <StepHeaderItem
          description="description"
          headline="relocation.headline"
        >
          <TextField
            label="sourceAccount"
            name="provider.sourceAccount"
            placeholder="sourceAccount.placeholder"
            rules={{
              required: true,
              pattern:
                /^(https?:\/\/)?(www\.)?[a-z0-9A-Z-.üöäßÜÖÄ]*\.[a-z]{2,7}(:\d+)?(\/.*)?$/,
            }}
          />
        </StepHeaderItem>
      </NewSection>
      <NewSection>
        <Section.Item>
          <StepHeaderItem
            description="description"
            headline="credentials.headline"
          />
          <ColumnLayout medium={[1, 1]}>
            <TextField
              label="providerName"
              name="provider.name"
              rules={{
                required: true,
              }}
            />
            <TextField
              label="providerLoginUrl"
              name="provider.loginUrl"
              rules={{
                required: true,
                pattern:
                  /^(https?:\/\/)?(www\.)?[a-z0-9A-Z-.üöäßÜÖÄ]*\.[a-z]{2,7}(:\d+)?(\/.*)?$/,
              }}
            />
            <TextField
              autoComplete={undefined}
              label="providerUsername"
              name="provider.userName"
              rules={{
                required: true,
              }}
            />
            <TextField
              autoComplete={undefined}
              infoMessage={{
                message: "providerPassword.infoMessage",
              }}
              label="providerPassword"
              name="provider.password"
              rules={{
                required: true,
              }}
              type="password"
            />
          </ColumnLayout>
          <CheckBox
            name="allowPasswordChange"
            rules={{ required: true }}
            title="allowPasswordChange"
          />
        </Section.Item>
      </NewSection>
    </TranslationProvider>
  );
};
